// 실시간문의 열기 요청 — 다른 화면(AI 차량 확인의 [이 내용으로 상담하기] 등)이 초안 글과 함께 채팅 패널을 열 때 쓴다.
// 위젯(useWebChat)이 구독해 패널을 열고 새 문의 입력창에 초안을 넣는다
const EVENT = 'quinors:chat-open';

export function openChatWithDraft(draft = '') {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { draft: String(draft || '') } }));
}

export function subscribeChatOpen(handler) {
  const fn = (e) => handler((e.detail && e.detail.draft) || '');
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}
